import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Info de pago',
    payouts: 'Pagos',
  },
  form: {
    invoicing_emails: {
      label: 'Enviar facturas a',
      placeholder: 'Introduce tu correo',
    },
    payout_schedule: {
      label: 'Calendario de pagos',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Pagos pausados',
        [PAYOUT_INTERVAL.DAILY]: 'Pagos diarios',
        [PAYOUT_INTERVAL.WEEKLY]: 'Pagos semanales',
        [PAYOUT_INTERVAL.MONTHLY]: 'Pagos mensuales',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurante',
    amount: 'Importe',
    cash_amount: 'Importe en efectivo',
    paypal_standalone_amount: 'Importe PayPal',
    period: 'Período',
    paid_at: 'Pagado el',
    provider: 'Proveedor',
    status: 'Estado',
    actions: 'Acciones',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Efectivo',
    system: 'Sistema',
  },
  buttons: {
    save: 'Guardar',
    actions: 'Acciones',
    open_report: 'Abrir informe',
    open_tracking_url: 'Rastrear pago',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'Pendiente',
    [PAYOUT_STATUSES.processing]: 'Procesando',
    [PAYOUT_STATUSES.paid]: 'Pagado',
    [PAYOUT_STATUSES.failed]: 'Fallido',
    undefined: 'Desconocido',
    null: 'Desconocido',
  },
  toasts: {
    failed_to_load_data: 'Error al obtener los datos',
    successfully_updated: 'Actualizado correctamente',
  },
};
